import { passThroughAxios } from './passThrough.axios'

export default {
  async uploadToStaging(file) {
    const formData = new FormData()
    formData.append('file', file)
    const response = await passThroughAxios.post('file-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },
}
